import type { JSONContent } from '@sequencehq/core-components'
import type { ImageBlockConfig, QuoteBlock } from '@sequencehq/quote-content'
import { alignmentIn } from './textBlockAttributes'

/**
 * Converts between saved image blocks and the editor's images. A width is
 * only saved once the image has been resized.
 */
export const imageAdapter = {
  in: (block: QuoteBlock): JSONContent => {
    const config = block.config as ImageBlockConfig

    return {
      type: 'image',
      attrs: {
        src: config.src,
        alt: config.alt ?? '',
        width: config.width ?? null,
        textAlign: alignmentIn(config.textAlignment)
      }
    }
  },
  out: (node: JSONContent): QuoteBlock => {
    const { src, alt, width, textAlign } = node.attrs ?? {}
    const hasWidth = typeof width === 'number'

    return {
      blockType: 'image',
      config: {
        src: src ?? '',
        alt: alt ?? '',
        ...(hasWidth && { width }),
        textAlignment: textAlign ?? 'left'
      },
      version: 1
    }
  }
}
